import axios from "axios";

export function formatNumber(value: any) {
  if (isNaN(value)) {
    return "0";
  }

  const number = parseFloat(value);

  if (number === 0) {
    return "0";
  }

  // Check if the integer part is 0 and the decimal part has more than 5 leading zeros
  const [integerPart, decimalPart] = value.toString().split(".");
  if (integerPart === "0" && decimalPart && /^0{5,}/.test(decimalPart)) {
    return number.toExponential();
  }

  // Format number with commas
  return number.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20, // Adjust this as needed
  });
}

export function formatVolume(volume_24h: number) {
  if (volume_24h >= 1e9) {
    return (volume_24h / 1e9)?.toFixed(2) + " B";
  } else if (volume_24h >= 1e6) {
    return (volume_24h / 1e6)?.toFixed(2) + " M";
  } else if (volume_24h >= 1e3) {
    return (volume_24h / 1e3)?.toFixed(2) + " K";
  } else {
    return volume_24h?.toFixed(2);
  }
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string) => {
  return password.length >= 6;
};
export function formatTime(minutes: number, seconds: number) {
  minutes = Math.max(0, Math.floor(minutes));
  seconds = Math.max(0, Math.floor(seconds));

  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
}

const resizeImage = (
  file: any,
  maxWidth: number,
  maxHeight: number
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Tính toán kích thước mới dựa trên tỷ lệ
      let ratio = 1;
      if (img.width > maxWidth) {
        ratio = maxWidth / img.width;
      } else if (img.height > maxHeight) {
        ratio = maxHeight / img.height;
      }

      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;

      // Vẽ lại ảnh lên canvas với kích thước mới
      ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

      // Chuyển canvas thành dữ liệu Blob
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Không thể tạo Blob"));
        } else {
          resolve(blob);
        }
      }, file.type);
    };

    // Đọc dữ liệu của file ảnh
    const reader = new FileReader();
    reader.onload = (e) => {
      if (typeof e.target?.result === "string") {
        img.src = e.target.result;
      } else {
        reject(new Error("Không thể đọc file ảnh"));
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};


export const handleUploadFile = async (file: any) => {
  try {
    // Giảm kích thước ảnh
    const resizedBlob = await resizeImage(file, 800, 600);

    // Tạo FormData để gửi lên server
    const formData = new FormData();
    formData.append("file", resizedBlob, file.name);

    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/member/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (res && res.data) {
      return res.data.url; // Trả về URL của file đã tải lên thành công
    } else {
      throw new Error("Không có dữ liệu phản hồi từ server");
    }
  } catch (error: any) {
    console.error("Lỗi khi tải lên file:", error);
    throw new Error(error.message || "Có lỗi xảy ra khi tải lên file");
  }
};